var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoTavle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#ef6545"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.355,11.988H9.228V6.573A.563.563,0,0,0,9.242,6.5a.542.542,0,0,0-.014-.07V6.357H9.212A.531.531,0,0,0,8.7,5.966H5.649a.538.538,0,1,0,0,1.075h.712v4.947H5.236a.538.538,0,1,0,0,1.075h5.119a.538.538,0,0,0,0-1.075Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8,4.805A1.426,1.426,0,1,0,6.369,3.379,1.426,1.426,0,0,0,7.8,4.805Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTavle);
export default __webpack_public_path__ + "static/media/INFO-TAVLE.bdedac8e6cb81a97f0945afdc5048df0.svg";
export { ForwardRef as ReactComponent };